// Geteilter Drag-Zustand des Builders.
// Setzt window.__ehInternalBuilderDrag, damit das globale Datei-Upload-Overlay
// (useGlobalFileDrop) Builder-Drags ignoriert – exakt wie in der Legacy-Welt.

import type { BuilderScope } from "./fieldModel";

export type DragKind = "template" | "field" | "inline-option";

interface DragPayload {
  kind: DragKind;
  scope: BuilderScope;
  templateId?: string;
  fieldUid?: string;
  optionIndex?: number;
  optionFieldUid?: string;
}

let current: DragPayload | null = null;

declare global {
  interface Window {
    __ehInternalBuilderDrag?: boolean;
    __ehInternalBuilderDragType?: string;
  }
}

export function beginDrag(payload: DragPayload): void {
  current = payload;
  if (typeof window !== "undefined") {
    window.__ehInternalBuilderDrag = true;
    window.__ehInternalBuilderDragType = payload.kind;
  }
}

export function endDrag(): void {
  current = null;
  if (typeof window !== "undefined") {
    window.__ehInternalBuilderDrag = false;
    window.__ehInternalBuilderDragType = "";
  }
}

export function getDrag(): DragPayload | null {
  return current;
}
